import React from "react";
import { ArrowRight, ArrowLeft } from "@speedoc/design-assets/build/icons";

export default function Pagination({ currentPage, totalPage, onChange }) {
  const isFirstThree = currentPage <= 3;
  const isLastThree = totalPage - currentPage < 3;

  const ButtonPage = ({ page }) => {
    const isCurrentPage = page === currentPage;
    const onClick = () => !isCurrentPage && onChange(page);
    return (
      <div className={`buttonPage ${isCurrentPage ? "selected" : ""}`} onClick={onClick}>
        {page}
      </div>
    );
  };

  const onClickPrevious = () => onChange(currentPage - 1);
  const onClickNext = () => onChange(currentPage + 1);

  return totalPage > 7 ? (
    <div className="paginationContainer">
      {currentPage !== 1 && <ArrowLeft onClick={onClickPrevious} className="arrow left" />}
      {<ButtonPage page={1} />}
      {isFirstThree ? (
        <>
          <ButtonPage page={2} />
          <ButtonPage page={3} />
        </>
      ) : (
        <div>...</div>
      )}
      {currentPage === 3 && <ButtonPage page={currentPage + 1} />}
      {!isFirstThree && !isLastThree && (
        <>
          <ButtonPage page={currentPage - 1} />
          <ButtonPage page={currentPage} />
          <ButtonPage page={currentPage + 1} />
        </>
      )}
      {currentPage === totalPage - 2 && <ButtonPage page={currentPage - 1} />}
      {isLastThree ? (
        <>
          <ButtonPage page={totalPage - 2} />
          <ButtonPage page={totalPage - 1} />
        </>
      ) : (
        <div>...</div>
      )}
      {<ButtonPage page={totalPage} />}
      {currentPage !== totalPage && <ArrowRight onClick={onClickNext} className="arrow right" />}
    </div>
  ) : (
    <div className="paginationContainer">
      {Array.from(Array(totalPage || 0), (_, i) => {
        return <ButtonPage page={i + 1} key={i} />;
      })}
    </div>
  );
}
